import { BackendErrorCode, type BackendErrorEntity, type ErrorType } from '~/apiClient';

export interface UseSlpWatchersProps {
    error: Ref<ErrorType<BackendErrorEntity> | null>;
    refetch: () => void;
}

export const useSlpWatchers = ({ error, refetch }: UseSlpWatchersProps): void => {
    // COMPOSABLES
    const { isLoggedIn } = useAuthUtils();

    // WATCHERS
    watchEffect(() => {
        if (
            error.value?.statusCode === 400 &&
            error.value.data?.error?.code &&
            [BackendErrorCode.InvalidUUID, BackendErrorCode.InvalidEnumValue, BackendErrorCode.InvalidUrlKeyValue].includes(
                error.value.data?.error?.code
            )
        ) {
            showError({ status: 404 });
        } else if (error.value) {
            showError({ status: 500 });
        }
    });

    watch(isLoggedIn, (value, oldValue) => {
        value !== oldValue && refetch();
    });
};
